import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Navbar } from '../../components';
import { SinglePaymentResult } from '../home-students/components/form-single-payment/SinglePaymentResult';
import { useSinglePaymentResultState } from '../home-students/components/form-single-payment/useSinglePaymentResultState';
import { getLegacyPaymentRetryPath } from '../home-students/paymentFlowFallback';


export const FinishPaymentPage = () => {
  const navigate = useNavigate();
  const legacyRedirectPath = useMemo(() => getLegacyPaymentRetryPath(), []);
  const {
    errorMessage,
    hasSinglePaymentContext,
    isLoading,
    payment
  } = useSinglePaymentResultState();

  useEffect(() => {
    if (hasSinglePaymentContext || !legacyRedirectPath) {
      return;
    }
    navigate(legacyRedirectPath);
  }, [hasSinglePaymentContext, legacyRedirectPath, navigate]);

  if (hasSinglePaymentContext) {
    return (
      <>
        <Navbar />
        <div className='pt-20 pb-20 sm:pt-[7rem] sm:pb-[7rem] px-4 sm:px-6 lg:px-10 w-full min-h-screen flex justify-center' style={{ background: '#F9F9F9' }}>
          <SinglePaymentResult
            errorMessage={errorMessage}
            isLoading={isLoading}
            payment={payment}
            status={payment?.status}
          />
        </div>
      </>
    );
  }

  if (legacyRedirectPath) {
    return <div className='relative h-screen w-screen flex justify-center items-center'><ProgressSpinner /></div>;
  }

  return (
    <>
      <Navbar />
      <div className='pt-20 pb-20 sm:pt-[7rem] sm:pb-[7rem] px-4 sm:px-6 lg:px-10 w-full min-h-screen flex justify-center' style={{ background: '#F9F9F9' }}>
        <SinglePaymentResult
          errorMessage='No fue posible recuperar la información de este pago. Abre nuevamente el enlace original para validar el resultado.'
          payment={null}
          status={null}
        />
      </div>
    </>
  );
};
